import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

import { ICD10_CHIP_HEIGHT } from '../medicineSelector.constants';

export const StyledMedicineSelectorActionInputLabel = styled.div`
   flex: 0 0 auto;
   display: flex;
   align-items: center;
   min-height: ${ICD10_CHIP_HEIGHT};
`;

StyledMedicineSelectorActionInputLabel.displayName = 'StyledMedicineSelectorActionInputLabel';

export const StyledMedicineSelectorActionInputCustomContent = styled(StyledFlex)`
   width: 100%;
`;

StyledMedicineSelectorActionInputCustomContent.displayName = 'StyledMedicineSelectorActionInputCustomContent';
